import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Input,
  message,
  PageHeader,
  Form,
  Row,
  Col,
  DatePicker,
  Spin,
  Typography,
  Table,
  Divider,
} from "antd";

import moment from "moment";
import Page from "_components/Page";
import TabMenu from "./TabMenu";

import { stockReceiptService } from "_services";
import Text from "antd/lib/typography/Text";

function ReceiptDetails({ history, match }) {
  const { id } = match.params;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    getStockReceipt(id);
  }, []);

  const getStockReceipt = (receiptId) => {
    setLoading(true);
    stockReceiptService
      .getStockReceiptByPurchaseOrderId(receiptId)
      .then((data) => {
        setLoading(false);
        if (data) {
          let receipt = data.content;

          receipt.orderDate = moment(receipt.orderDate);
          receipt.expectedDate = moment(receipt.expectedDate);
          receipt.deliveryDate = moment(receipt.deliveryDate);

          setOrder(receipt);
          onFill(receipt);
        }
      })
      .catch((errorInfo) => {
        setLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const onFill = (data) => {
    form.setFieldsValue(data);
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Receipt No",
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      render: (text, record) => (
        <Link to={`/stock-receipts/${record.receiptId}/summary`}>
          {text}
        </Link>
      ),
    });
    columns.push({
      title: "Material",
      dataIndex: "stockTypeCode",
      key: "stockTypeCode",
    });
    columns.push({
      title: "Description",
      dataIndex: "stockType",
      key: "stockType",
      ellipsis: {
        showTitle: false,
      },
    });
    columns.push({
      title: "Packing Type",
      dataIndex: "packingType",
      key: "packingType",
      //render: (text, record) => record.packingType?.name,
    });
    columns.push({
      title: "Rec’d. Pallets",
      dataIndex: "receivedStorageUnits",
      key: "receivedStorageUnits",
      align: "right",
    });

    columns.push({
      title: "Rec’d. Qty",
      dataIndex: "receivedPackageQuantity",
      key: "receivedPackageQuantity",
      align: "right",
    });

    columns.push({
      title: "Currency Type",
      dataIndex: "currencyType",
      key: "currencyType",
    });

    return columns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/purchase-orders">Purchase Orders Search</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page inner error={error}>
          <TabMenu menu="receipt-details" id={id} />
          <Spin tip="Loading..." spinning={loading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="orderNumber"
                    label="Order Number"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="supplierCompany"
                    label="Supplier"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="store"
                    label="Store"
                    rules={[{ required: true }]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="orderDate"
                    label="Order Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder="Order Date"
                      style={{ width: "100%" }}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="deliveryDate"
                    label="Delivery Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder="Delivery Date"
                      style={{ width: "100%" }}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="expectedDate"
                    label="Expected Date"
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      placeholder="Expected Date"
                      style={{ width: "100%" }}
                      readOnly
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Divider orientation="left">Stock Receipts</Divider>

              {order &&
                order.stockReceipts &&
                order.stockReceipts.length > 0 && (
                  <>

                    <Table
                      bordered
                      pagination={false}
                      columns={getLineColumns()}
                      dataSource={order.stockReceipts}
                      size="small"
                      summary={(pageData) => {
                        let totalReceivedStorageUnits = 0;
                        let totalReceivedPackages = 0;

                        pageData.forEach(
                          ({
                            receivedStorageUnits,
                            receivedPackageQuantity,
                          }) => {
                            totalReceivedStorageUnits +=
                              Number(receivedStorageUnits) || 0;
                            totalReceivedPackages +=
                              Number(receivedPackageQuantity) || 0;
                          }
                        );

                        return (
                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={4}>
                              <Text strong>Total</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                              <Text strong>{totalReceivedStorageUnits}</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                              <Text strong>{totalReceivedPackages}</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        );
                      }}
                    />
                  </>
                )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default ReceiptDetails;
